module.exports = __webpack_public_path__ + "static/media/corporate-services-img94.0e745ffd.jpg";